import { render, staticRenderFns } from "./NotiSendOffcanvas.vue?vue&type=template&id=3f528d1a"
import script from "./NotiSendOffcanvas.vue?vue&type=script&lang=js"
export * from "./NotiSendOffcanvas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports